module.exports = __webpack_public_path__ + "media/images/redesign-images/misc/new-member-banner-90eacf4ba71edd6e2adf618954e1a5a5.jpg";